import { cloneElement, isValidElement, ReactElement, useRef } from "react";
import PropTypes from "prop-types";
import { useIntersection } from "utils/useIntersection";
interface VisibleViewProps {
    rootMargin?: string;
    children: ReactElement;
}

function VisibleView(props: VisibleViewProps) {
    const { rootMargin = "-100px", children } = props;
    const visibleRef: any = useRef();
    const isVisible = useIntersection(visibleRef, rootMargin);
    if (isValidElement(children)) {
        const Container = cloneElement<any>(children, {
            isVisible,
            visibleRef,
        });
        return Container;
    }
    return children;
}

VisibleView.propTypes = {
    rootMargin: PropTypes.string,
    children: PropTypes.node,
};

export default VisibleView;
